import i18n from 'modules/core/lib/i18n'

import { CostCenterAssignment } from 'modules/finance/lib/costCenterAssignments'

import { CostCenterAssignmentBaseCard } from '../BaseCard'
import { ManageAssignments } from '../ManageAssignments'
import { CreateButton } from './components/CreateButton'

interface Props {
  legalEntityIds: number[]
  resourceId: number
  onCancel: () => void
  onSave: () => void
  allAssignments: CostCenterAssignment[]
}

export const NewAssignmentCard = ({
  legalEntityIds,
  resourceId,
  onCancel,
  onSave,
  allAssignments,
}: Props) => {
  return (
    <CostCenterAssignmentBaseCard focus>
      <ManageAssignments
        legalEntityIds={legalEntityIds}
        resourceId={resourceId}
        title={i18n.t('finance.cost_centers.assignments.new_assignment_card.title')}
        description={i18n.t('finance.cost_centers.assignments.new_assignment_card.description')}
        onCancel={onCancel}
        onSave={onSave}
        allAssignments={allAssignments}
        customSaveButton={(assignmentsToCreate, _assignmentsToUpdate, disabled) => (
          <CreateButton
            assignments={assignmentsToCreate}
            resourceId={resourceId}
            disabled={disabled}
            onSave={onSave}
          />
        )}
      />
    </CostCenterAssignmentBaseCard>
  )
}
